import { render, staticRenderFns } from "./PauseAudio.vue?vue&type=template&id=7810f78a"
import script from "./PauseAudio.vue?vue&type=script&lang=js"
export * from "./PauseAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports